(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  var id    = '{{ section.id }}';
  var track = document.getElementById('ws-track-' + id);
  var outer = document.getElementById('ws-track-outer-' + id);
  var prev  = document.getElementById('ws-prev-' + id);
  var next  = document.getElementById('ws-next-' + id);

  if (!track || !outer || !prev || !next) return;

  var cards = track.querySelectorAll('.ws-card');

  function cardStep() {
    if (!cards.length) return 0;
    var first = cards[0];
    var second = cards[1];
    if (second) {
      return second.offsetLeft - first.offsetLeft;
    }
    return first.offsetWidth + 16;
  }

  function updateArrows() {
    prev.disabled = outer.scrollLeft <= 4;
    next.disabled = outer.scrollLeft >= outer.scrollWidth - outer.clientWidth - 4;
  }

  prev.addEventListener('click', function () {
    outer.scrollBy({ left: -cardStep(), behavior: 'smooth' });
  });

  next.addEventListener('click', function () {
    outer.scrollBy({ left: cardStep(), behavior: 'smooth' });
  });

  outer.addEventListener('scroll', updateArrows);
  window.addEventListener('resize', updateArrows);

  updateArrows();
})();

(function () {
  if (window.__wsAddToCartInit) return;
  window.__wsAddToCartInit = true;

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], #cart-icon-bubble .cart-count-bubble span:first-child')
          .forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {
        /* Lenient: if the count can't be refreshed, the add itself
           already succeeded — fail silently rather than alarming the shopper. */
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.ws-card [data-product-form]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[data-add-btn]');
    if (!button || button.disabled) return;

    button.classList.remove('is-error');
    button.classList.add('is-loading');
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        updateCartCount();
        setTimeout(function () {
          button.classList.remove('is-added');
          button.disabled = false;
        }, 1800);
      })
      .catch(function (err) {
        button.classList.remove('is-loading');
        button.classList.add('is-error');
        button.disabled = false;
        setTimeout(function () { button.classList.remove('is-error'); }, 1400);
        console.error('Add to cart failed:', err);
      });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
